export function awardsHistory() {
    $('.show-more-awards button').on('click', function () {
        const $this = $(this);
        $this.closest('.awards-listing-wrap').find('.hidden').removeClass('hidden');
        $this.hide();
    })

    const $window = $(window);
    const timeline = $(".awards-history");
    const timelineItems = timeline.find(".awards-row");
    let $windowWidth = $window.width();
    let $windowHeight = $window.height();
    let scrollTop;
    let resizeTimeout;

    function timeLineAnimate() {
        $windowHeight = $window.height();
        timelineItems.each(function () {
            const $this = $(this);
            const itemHeight = $this.outerHeight(true);
            const itemOffsetTop = $this.offset().top;
            $this.attr("data-height", itemHeight);
            $this.attr("data-offset-top", itemOffsetTop);
            if ((scrollTop + $windowHeight / 2 >= itemOffsetTop + itemHeight / 2 - 16)) {
                if (!$this.hasClass('active')) {
                    $this.addClass('active');
                }
            } else {
                $this.removeClass('active');
            }
        })
    }

    $window.on("scroll load", function () {
        if ($windowWidth > 1023) {
            scrollTop = $(document).scrollTop();
            timeLineAnimate();
        }
    });

    $window.on("resize", function () {
        $windowWidth = $window.width();
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(() => {
            timeLineAnimate();
        }, 100)
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/awardsHistory.js